import { Link } from 'react-router'
import { NewsKicker } from '../news-meta/NewsKicker.tsx'
import { NewsMeta } from '../news-meta/NewsMeta.tsx'
import styles from './StoryHero.module.css'

export interface StoryHeroProps {
  to: string
  title: string
  excerpt?: string
  coverUrl?: string | null
  /** Topic label above the headline. */
  kicker?: string
  /** Shows the "Featured" flag beside the kicker. */
  featured?: boolean
  featuredLabel?: string
  author?: string
  date?: string | null
  readTimeMinutes?: number
  /** Heading level for the headline; pick for document outline. */
  as?: 'h2' | 'h3'
  className?: string
}

/**
 * The lead story on a news front page: a full-bleed cover with the headline,
 * dek and byline on a panel across its foot. On a phone the panel moves below
 * the image so the cover is never hidden behind text.
 */
export function StoryHero({
  to,
  title,
  excerpt,
  coverUrl,
  kicker,
  featured,
  featuredLabel = 'Featured',
  author,
  date,
  readTimeMinutes,
  as: Heading = 'h2',
  className,
}: StoryHeroProps) {
  return (
    <Link to={to} className={[styles.hero, className].filter(Boolean).join(' ')}>
      {coverUrl
        ? <img className={styles.cover} src={coverUrl} alt="" />
        : <div className={styles.placeholder} aria-hidden="true" />}
      <div className={styles.panel}>
        {(kicker || featured) && (
          <div className={styles.flags}>
            {kicker && <NewsKicker>{kicker}</NewsKicker>}
            {featured && <span className={styles.badge}>{featuredLabel}</span>}
          </div>
        )}
        <Heading className={styles.title}>{title}</Heading>
        {excerpt && <p className={styles.excerpt}>{excerpt}</p>}
        <NewsMeta author={author} date={date} readTimeMinutes={readTimeMinutes} />
      </div>
    </Link>
  )
}
